import React from 'react'
import { Theme, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { IPostElementProps } from '../../../../types/types'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'inline-block',
    color: theme.palette.text.secondary,
    padding: '',
  },
}))

const SubHeadline: React.FC<IPostElementProps> = (props) => {
  const classes = useStyles()
  const value = props.value

  return (
    <>
      {value && <Typography variant='body2' color='#B1B1B1' className={classes.root}>{value}</Typography>}
    </>
  )
}

export default SubHeadline
